// Mobile-viewport gate.
//
// Renders a full-screen "Please open this on a computer" message instead of
// the form whenever the viewport is narrower than 1024px. Above 1024px,
// renders {children} unchanged.
//
// The check uses matchMedia + a 'change' listener so the gate appears /
// disappears live as the user resizes the browser — no page reload needed.
// Mounting this above the routes means the form code never even runs on
// mobile, so we don't need responsive CSS in any individual step.
import { useEffect, useState } from 'react'

const MOBILE_QUERY = '(max-width: 1023px)'

function readInitial() {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(MOBILE_QUERY).matches
}

export default function MobileGate({ children }) {
  const [isMobile, setIsMobile] = useState(readInitial)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(MOBILE_QUERY)
    const onChange = (e) => setIsMobile(e.matches)
    // Sync once in case SSR-ish initial state was wrong, then subscribe.
    setIsMobile(mql.matches)
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    }
    // Safari < 14 fallback
    mql.addListener(onChange)
    return () => mql.removeListener(onChange)
  }, [])

  if (!isMobile) return children

  return (
    <div className="mobile-gate" role="dialog" aria-modal="true">
      <div className="mobile-gate-inner">
        <div className="mobile-gate-logo">BRITE</div>
        <h1 className="mobile-gate-title">Please open this on a computer</h1>
        <p className="mobile-gate-body">
          BRITE onboarding includes signing contracts, uploading documents,
          and connecting payment — all of which work best on a desktop or
          laptop browser.
        </p>
        <p className="mobile-gate-body mobile-gate-body-secondary">
          Open this same link on your computer to continue. We've saved your
          spot — nothing is lost.
        </p>
        <p className="mobile-gate-help">
          Need help? Email{' '}
          <a href="mailto:support@brite.live" className="mobile-gate-link">
            support@brite.live
          </a>
        </p>
      </div>
    </div>
  )
}
